import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { DiscountGroupProductRelation, DiscountGroupProductRelationSearchInput, Operator, Product } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { ProductDropDownComponent } from "../../modules/product-chooser/product-dropdown.component";
import { DiscountGroupProductRelationService } from "../../services/discount-group-product-relation.service";

@Component({
  selector: 'app-discount-group-product-relation-widget',
  // templateUrl: './discount-group-product-relation-widget.component.html'
  //
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent,
  ]
})
export class DiscountGroupProductRelationWidgetComponent extends NewBaseListComponent<DiscountGroupProductRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupProductRelationService: DiscountGroupProductRelationService,
  ) {
    super("DiscountGroupProductRelation", discountGroupProductRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupProductRelationSearchInput {
    let si: DiscountGroupProductRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let productIdentifierCol: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'product.identifier' || (x.prop === "identifier" && x.entityType === 'Product'));
    if (productIdentifierCol) {
      productIdentifierCol.getEditComponent = () => ProductDropDownComponent;
      productIdentifierCol.editComponentCreated = async (c: ProductDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.product)
          c.setModel(rowData.product);
        else if (rowData?.productId) {
          await c.loadItemByIdAndSetSelected(rowData.productId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe(async (x: Product) => {
          rowData.productId = x?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupProductRelation): Promise<DiscountGroupProductRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
